// Configuration centralisée des intentions du placeholder animé AYA Search (v5.7.0).
// Ajouter / modifier une intention = une seule ligne ici.
export const SEARCH_INTENTS = [
  "Je cherche un avocat",
  "Je veux voir un médecin",
  "Je cherche un plombier",
  "Je cherche un coiffeur",
  "Trouve-moi un restaurant à Cocody",
  "Je cherche une pharmacie ouverte",
  "Je veux réserver un hôtel",
  "Je cherche un taxi",
  "Je cherche un emploi",
  "Je cherche une banque",
  "Je veux acheter un téléphone",
  "Je cherche un artisan",
  "Je cherche un garage",
  "Je cherche une école",
  "Je cherche une salle de sport",
  "Je cherche un maquis",
  "Je cherche un fournisseur",
  "Je veux voir les événements",
  "Je cherche un service public",
  "Je cherche un billet d'avion",
  "Je veux découvrir la Côte d'Ivoire",
  "Quelles sont les actualités aujourd'hui ?",
];
